//import locationRes from '../resources/location.resource';
import Selector, { selectorTpl, REQUIRED_IMPORTS } from './selector/selector.component';


class JobtitleSelectorComponent extends Selector {
  constructor($timeout, $q, gettextCatalog) {
    super(gettextCatalog.getString('Valitse rooli'));

    //this.LocationResource = LocationResource;

    /**
     * Jobtitle set by the parent component.
     * @type {object}
     */
    this.jobtitle = null;

    /**
     * Callback to call when object is selected.
     * @type {Function}
     */
    this.selectCallback = null;

    this.loaded = false;

    this.$timeout = $timeout;
    this.$q = $q;

    /**
     * Jobtitles set by the parent component
     * @type {Array[object]}
    */
    this.jobtitles = [];
  }

  loadData() {
    return this.$q.when(this.jobtitles);
  }

  $onInit() {
    this.object = this.jobtitle;
    super.$onInit();
  }

  $onChanges() {
    this.object = this.jobtitle == null ? null : this.objs.find(jobtitle => jobtitle.label === this.jobtitle.label);
    super.$onChanges();
  }

  onPostInit() {
    this._setObject();
    this.loaded = true;
    this.$timeout(() => this.selectCallback({ jobtitle: this.object }));
  }

  onSelect() {
    super.onSelect();
    this.selectCallback({ jobtitle: this.object });
  }
}

const config = {
  templateUrl: selectorTpl,
  controller: JobtitleSelectorComponent,
  bindings: {
    jobtitle: '<',
    jobtitles: '<',
    selectCallback: '&',
    extraClasses: '@?'
  }
};

const mod = angular.module('app.component.jobtitleSelector', REQUIRED_IMPORTS)

  .component('jobtitleSelector', config)

  ;

export default mod.name;
